import { AccessibilityInfo, EmitterSubscription, Platform } from 'react-native';

class Announcement {
    static instance: Announcement;

    static log(message: string): void {
        if (__DEV__) {
            console.log(
                `[OneTV][Announcement log at ${new Date().toLocaleTimeString()}]: ${message}`,
            );
        }
    }

    constructor() {
        if (Announcement.instance) {
            return Announcement.instance;
        }

        Announcement.instance = this;
        Announcement.log('initialized');
    }

    private subscription: EmitterSubscription | undefined;

    private resolveAnnouncement: (() => void) | undefined;

    private subscribe() {
        this.unsubscribe();
        this.subscription = AccessibilityInfo.addEventListener(
            'announcementFinished',
            async (e) => {
                if (!e.success) {
                    Announcement.log('announcement failed');
                    AccessibilityInfo.announceForAccessibility(e.announcement);
                } else {
                    Announcement.log('announcement succeeded');
                    this.resolveAnnouncement?.();
                    this.unsubscribe();
                }
            },
        );
        Announcement.log('subscribed');
    }

    private unsubscribe() {
        if (this.subscription) {
            this.subscription.remove();
            this.subscription = undefined;
            Announcement.log('unsubscribed');
        }
    }

    public async announce(message: string, queue?: boolean): Promise<void> {
        const screenReaderEnabled =
            await AccessibilityInfo.isScreenReaderEnabled();

        if (screenReaderEnabled) {
            if (Platform.OS === 'ios') {
                Announcement.log(`create ios announcement: {$message}`);

                return new Promise<void>((resolve) => {
                    this.resolveAnnouncement = resolve;
                    this.subscribe();

                    AccessibilityInfo.announceForAccessibilityWithOptions(
                        message,
                        {
                            queue,
                        },
                    );
                });
            }

            if (Platform.OS === 'android') {
                Announcement.log(`create android announcement: {$message}`);
                AccessibilityInfo.announceForAccessibility(message);
            }

            Announcement.log(`resolve android announcement: ${message}`);
        }

        return Promise.resolve();
    }
}

export default Announcement;
